exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-label[data-v-29ed4a9e] {\n  line-height: 1;\n  margin-bottom: 0;\n}\n.radio-input[data-v-29ed4a9e] {\n  accent-color: #085FCE;\n  margin: 0;\n}\n.radio-input-wrapper *[data-v-29ed4a9e],\n.radio-input-wrapper[data-v-29ed4a9e] {\n  cursor: pointer;\n}\nlabel[data-v-29ed4a9e] {\n  color: #484848 !important;\n}", ""]);

// exports
